module.exports = {
  "zones": {
    "US/East-Indiana": ["z", {
      "wallclock": 1136073600000,
      "format": "E%sT",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": 1136091600000,
      "save": 0,
      "rules": "US"
    }, {
      "wallclock": 31536000000,
      "format": "EST",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": 31554000000,
      "save": 0
    }, {
      "wallclock": -31536000000,
      "format": "E%sT",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": -31518000000,
      "save": 0,
      "rules": "US"
    }, {
      "wallclock": -368661600000,
      "format": "EST",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": -368640000000,
      "save": 0
    }, {
      "wallclock": -386805600000,
      "format": "CST",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -386787600000,
      "save": 0
    }, {
      "wallclock": -463615200000,
      "format": "EST",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": -463593600000,
      "save": 0
    }, {
      "wallclock": -757382400000,
      "format": "C%sT",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -757360800000,
      "save": 0,
      "rules": "Indianapolis"
    }, {
      "wallclock": -883612800000,
      "format": "C%sT",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -883591200000,
      "save": 0,
      "rules": "US"
    }, {
      "wallclock": -1577923200000,
      "format": "C%sT",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -1577901600000,
      "save": 0,
      "rules": "Indianapolis"
    }, {
      "wallclock": -2717667878000,
      "format": "C%sT",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -2717647200000,
      "save": 0,
      "rules": "US"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -20678000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "US": [{
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, 8],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 10,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1967,
      "to": 2006,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1987,
      "to": 2006,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1976,
      "to": 1986,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1975,
      "to": 1975,
      "month": 1,
      "day": [7, 23],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1974,
      "month": 0,
      "day": [7, 6],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1967,
      "to": 1973,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 7,
      "day": [7, 14],
      "time": 1380,
      "clock": "posix",
      "save": 60,
      "letter": "P",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 1,
      "day": [7, 9],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "W",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1919,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1919,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }],
    "Indianapolis": [{
      "from": 1941,
      "to": 1954,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1946,
      "to": 1954,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1941,
      "to": 1941,
      "month": 5,
      "day": [7, 22],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }]
  }
};